const loadedFeatures = new Map();

/**
 * Ensures a feature is only initialized once
 * Sync version, returns the feature
 * Use for Vue initialization
 */
export function ensureFeature(name, fn) {
    if (loadedFeatures.has(name)) {
        return loadedFeatures.get(name);
    }

    const result = fn(); // direct uitvoeren (SYNC)
    loadedFeatures.set(name, result);
    return result;
}

/**
 * Ensures a feature is only initialized once
 * Async version, returns a promise
 * Use for async initialization
 * Like Vuex modules, heavy libraries, API bootstrapping
 */
export function ensureFeatureAsync(name, fn) {
    if (loadedFeatures.has(name)) {
        return loadedFeatures.get(name);
    }

    const promise = Promise.resolve().then(fn);
    loadedFeatures.set(name, promise);
    return promise;
}

/**
 * Check if a feature is already loaded
 */
export function isFeatureLoaded(name) {
    return loadedFeatures.has(name);
}
